import { CircularProgress, makeStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import format from "date-fns/format";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { FacematchAxiosClient } from "../../../Network/FacematchAxiosClient";
import { selectUser } from "../../../store/selectors/auth";
import "../styles/reviewFaceMatching.scss";
import user from "../svgs/account_circle.svg";
import bkash from "../svgs/bKash_Logo_Icon_Outlined.svg";
import work from "../svgs/home_work.svg";
import magic from "../svgs/magic_button.svg";
import map from "../svgs/map_pin_location.svg";
import schedule from "../svgs/schedule.svg";
import ChangeLog from "./changeLog";
import LocationMap from "./locationMap";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiPaper-root": {
      background: "#f2f2f2",
      padding: 20,
      maxWidth: "none",
      position: "relative",
    },

    "& .MuiBackdrop-root": {
      background: "#00000024",
    },
  },

  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

export default function ReviewModal({
  open,
  setOpen,
  details,
  loadTransferList,
}) {
  const [status, setStatus] = useState(null);
  const [showConfirmDialogMode, setShowConfirmDialogMode] = useState(null);
  const currentUser = useSelector(selectUser);
  const classes = useStyles();

  const handleClose = () => {
    setOpen(false);
  };

  const postDecision = (action) => {
    setStatus("loading");
    const obj = {
      id: details.id,
      actionPerformer: {
        name: currentUser.name,
        userType: currentUser.user_type,
        contactNumber: currentUser.contact_number,
      },
    };
    FacematchAxiosClient.post(`/selfie/${action}`, obj)
      .then((res) => {
        setStatus("success");
        // loadTransferList();
      })
      .catch((err) => {
        setStatus("failed");
      });
  };

  const handleClosingReviewModal = () => {
    setShowConfirmDialogMode(null);
    if (status === "success") {
      handleClose();
      loadTransferList();
    }
    setStatus(null);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.root}
      >
        {/* <DialogTitle id="alert-dialog-title">
          {"Review face matching"}
        </DialogTitle> */}

        <div style={{ display: "flex" }}>
          <InfoImages item={details} />
          <InfoLocation item={details} />
        </div>
        <div className="face-matching-button-container">
          {details.status !== false && (
            <Button
              className="button reject"
              onClick={() => setShowConfirmDialogMode("reject")}
            >
              {status === "loading" && (
                <CircularProgress
                  style={{ marginRight: 5, color: "rgba(238, 50, 53, 1)" }}
                  size={12}
                />
              )}
              {status === "loading" ? "Rejecting" : "Reject"}
            </Button>
          )}

          {details.status !== true && (
            <Button
              className="button approve"
              onClick={() => setShowConfirmDialogMode("approve")}
            >
              {status === "loading" && (
                <CircularProgress
                  style={{ marginRight: 5, color: "rgba(238, 50, 53, 1)" }}
                  size={12}
                />
              )}
              {status === "loading" ? "Approving" : "Approve"}
            </Button>
          )}
        </div>

        <ChangeLog changeLog={details.changeLog} />

        <ConfirmReviewDialog
          mode={showConfirmDialogMode}
          onAction={postDecision}
          callBackForClosing={handleClosingReviewModal}
          status={status}
        />
      </Dialog>
    </div>
  );
}

function ConfirmReviewDialog({ mode, onAction, callBackForClosing, status }) {
  return (
    <div className="transfer-item">
      <Dialog open={mode ? true : false} onClose={() => {}}>
        <div className="confirmation-overlay">
          {status === "loading" && (
            <div className="loading">
              <CircularProgress style={{ color: "#e91e63" }} />
            </div>
          )}
          <div className="text">
            {status === null && (
              <h3>Are you sure want to {mode} this face matching?</h3>
            )}
            {status === "success" ? (
              <p>
                Successfully {mode === "approve" ? "approved" : "rejected"} face
                matching
              </p>
            ) : status === "failed" ? (
              <p>Something went wrong. Pleast try again</p>
            ) : (
              <p></p>
            )}
          </div>
          {status === "success" || status === "failed" ? (
            <div className="btn-container">
              <Button className="button assign" onClick={callBackForClosing}>
                Ok
              </Button>
            </div>
          ) : (
            <div className="btn-container">
              {
                <Button
                  className="button assign"
                  onClick={() => onAction(mode)}
                >
                  Yes
                </Button>
              }
              <Button className="button outline" onClick={callBackForClosing}>
                No
              </Button>
            </div>
          )}
        </div>
      </Dialog>
    </div>
  );
}

function InfoImages({ item }) {
  return (
    <div className="info-images-container">
      <div className="info-images">
        <div className="image-with-text">
          <img src={item.imageUrl} className="image-container" alt="" />
          {item.status === true ? (
            <div className="title approve">Approved</div>
          ) : item.status === false ? (
            <div className="title reject">Rejected</div>
          ) : (
            <div className="title">Attendence selfie</div>
          )}
        </div>
        <div className="image-with-text">
          <img
            src={`${item.user.imageUrl}`}
            className="image-container"
            alt=""
          />
          <div className="title">Original</div>
        </div>
      </div>
      <div className="info-container">
        <div className="info">
          <img src={user} alt="field-force-id" />
          <div>
            <p>Employee Id</p>
            {item.employeeId}
          </div>
        </div>
        <div className="info">
          <img src={bkash} alt="whitelisting number" />
          <div>
            {" "}
            <p>Whitelisting number </p>+{item.userId}
          </div>
        </div>
        <div className="info">
          <img src={user} alt="field-force" />
          <div>
            <p>Name</p>
            {item.user ? item.user.name : "n/a"}
          </div>
        </div>

        <div className="info">
          <img src={magic} alt="face-match-score" />
          <div>
            <p>Face matching score</p>
            {isNaN(item.matchScore)
              ? "n/a"
              : `Face matched ${item.matchScore}%`}
          </div>
        </div>
        <div className="info">
          <img src={user} alt="field-force-manager" />
          <div>
            <p>Attendance Provider</p>
            {item.managerName ? item.managerName : "System"}
          </div>
        </div>
      </div>
    </div>
  );
}

function InfoLocation({ item }) {
  return (
    <div className="info-location-container">
      <LocationMap location={[item.lat, item.lon]} />
      <div className="info-container">
        <div className="info">
          <img src={schedule} alt="time" />
          <div>
            <p>Attendance date and time</p>
            {format(new Date(item.selfieTime), "dd MMM yyyy, h:mm a")}
          </div>
        </div>
        {item.user.distHouse ? (
          <div className="info">
            <img src={work} alt="work" />
            <div>
              <p>Distribution house</p>
              {item.user.distHouse}
            </div>
          </div>
        ) : (
          <div className="info">
            <img src={work} alt="face-match-score" />
            <div>
              {" "}
              <p>Agency</p>
              {item.user.agency}
            </div>
          </div>
        )}
        <div className="info">
          <img src={map} alt="lat" />
          <div>
            <p>Lattitude</p>
            {item.lat}
          </div>
        </div>
        <div className="info">
          <img src={map} alt="lon" />
          <div>
            <p>Longitude</p>
            {item.lon}
          </div>
        </div>
        <div className="info">
          <img src={map} alt="distance" />
          <div>
            <p>Distance from agemcy</p>
            {item.distanceFromAgency}
          </div>
        </div>
      </div>
    </div>
  );
}
